/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import CabecalhoListaDemanda from "../../components/ListaDemandas/CabecalhoListaDemanda";
import SidebarFiltros from "../../components/ListaDemandas/SidebarFiltrosComponent";
import { useAuth } from "../../contexts/UserContext";
import { clarity } from "react-microsoft-clarity";
import toast from "react-hot-toast";
import ModalDefault from "../../components/ModalDefault";
import ButtonDefault from "../../components/form/ButtonDefault";
import Checkbox from "../../components/form/InputCheckbox";
import { ModalContent, ModalTitle } from "../../components/Ui/DemandsFilter/styles";
import { useSidebarFiltros } from "../../contexts/SidebarFiltrosContext";
import api from "../../services/api";
import { Container } from "./styles";
import GruposDeAbasDeDemandas from "../../components/ListaDemandas/GrupoDeAbasDeDemandas";
import { IFiltroListaDemandas } from "../../types";
import ListaDemandasVazia from "../../components/ListaDemandas/ListaDemandasVazia";
import BlocoListaDemandas from "../../components/ListaDemandas/BlocoListaDemandas";
import { BlocoPrincipal } from "./styles";
import { IconClose } from "../../components/icons";


interface Pagination {
  pagina_atual: number;
  total_paginas: number;
  total_registros: number;
  registros_por_pagina: number;
}
export default function Demandas() {
    const containerRef = useRef<HTMLDivElement>(null);
    const { setPageType } = useAuth();
    const { isSidebarFiltrosOpen, setSidebarFiltrosOpen, filtros, setFiltros, resetFiltros } = useSidebarFiltros();

    const [gruposDeAbas, setGruposDeAbas] = useState<any[]>([])
    const [abasCarregando, setAbasCarregando] = useState<boolean>(false)
    const [abaAtiva, setAbaAtiva] = useState<number>(1)
    const [statusFiltro, setStatusFiltro] = useState<string[]>([])
    const [abasIniciais, setAbasIniciais] = useState<boolean>(true)
    const [listaDeDemandas, setListaDeDemandas] = useState<any[]>([])
    const [paginaAtual, setPaginaAtual] = useState<number>(1)
    const [paginacao, setPaginacao] = useState<Pagination>({
        pagina_atual: 1,
        total_paginas: 1,
        total_registros: 0,
        registros_por_pagina: 10
    })
    const [loading, setLoading] = useState<boolean>(false)
    const [openReportModal, setOpenReportModal] = useState<boolean>(false)
    const [checkedBox, setCheckedBox] = useState<string[]>([])

    useEffect(() => {
        setPageType('vazio');
    }, [setPageType]);

    function carregaFiltrosComuns(): any
    {
        const filtrosMapeados = {
            // Mapeamento dos campos específicos
            id: filtros.id,
            nome_operador: filtros.operador,
            nome_solicitante: filtros.solicitante,
            nome_correspondente: filtros.correspondente,
            comarcas: filtros.comarca,
            servicos: filtros.servico,
            numero_processo: filtros.numeroProcesso,
            parte_envolvida: filtros.parteEnvolvida,
            parte_representada: filtros.parteRepresentada,
            modalidades: filtros.modalidade,
            tipos_audiencia: filtros.tipoAudiencia,
            profissionais_necessarios: filtros.profissionalNecessario,
            // Filtros de valor
            valor_cliente: filtros.valorCliente?.valor,
            operador_valor: filtros.valorCliente?.operador,
            // Filtros de data
            prazo_fatal: filtros.prazoFatal?.data?.toISOString().split('T')[0],
            operador_prazo_fatal: filtros.prazoFatal?.operador,
            prazo_fatal_de: filtros.prazoFatal?.dataInicio?.toISOString().split('T')[0],
            prazo_fatal_ate: filtros.prazoFatal?.dataFim?.toISOString().split('T')[0],
            solicitada_em: filtros.solicitadaEm?.data?.toISOString().split('T')[0],
            operador_solicitada_em: filtros.solicitadaEm?.operador,
            solicitada_de: filtros.solicitadaEm?.dataInicio?.toISOString().split('T')[0],
            solicitada_ate: filtros.solicitadaEm?.dataFim?.toISOString().split('T')[0],
            prazo_aceite: filtros.prazoParaAceite?.data?.toISOString().split('T')[0],
            operador_prazo_aceite: filtros.prazoParaAceite?.operador,
            aceite_de: filtros.prazoParaAceite?.dataInicio?.toISOString().split('T')[0],
            aceite_ate: filtros.prazoParaAceite?.dataFim?.toISOString().split('T')[0],
            iniciada_em: filtros.iniciadaEm?.data?.toISOString().split('T')[0],
            operador_iniciada_em: filtros.iniciadaEm?.operador,
            iniciada_de: filtros.iniciadaEm?.dataInicio?.toISOString().split('T')[0],
            iniciada_ate: filtros.iniciadaEm?.dataFim?.toISOString().split('T')[0],
            prazo_conclusao: filtros.prazoParaConclusao?.data?.toISOString().split('T')[0],
            operador_prazo_conclusao: filtros.prazoParaConclusao?.operador,
            conclusao_de: filtros.prazoParaConclusao?.dataInicio?.toISOString().split('T')[0],
            conclusao_ate: filtros.prazoParaConclusao?.dataFim?.toISOString().split('T')[0]
        }

        const filtrosLimpos: any = {};
        Object.keys(filtrosMapeados).forEach(key => {
            const valor = (filtrosMapeados as any)[key];
            if (valor !== undefined && valor !== null) {
                filtrosLimpos[key] = valor;
            }
        });
        return filtrosLimpos;
    }

    function s2ab(s: any) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    function emiteRelatorio() {
        setOpenReportModal(true)
    }

    function handleCheckbox(name: string, value: boolean) {
        if (value) setCheckedBox([...checkedBox, name]);
        else setCheckedBox(checkedBox.filter(item => item !== name));
    }

    function handleToggleAll() {
        const allFields = Object.values(dataCheckbox).flatMap(section => section.map((item: any) => item.value));
        if (checkedBox.length === allFields.length) setCheckedBox([]);
        else setCheckedBox(allFields);
    }

    function isAllSelected() {
        const allFields = Object.values(dataCheckbox).flatMap(section => section.map((item: any) => item.value));
        return checkedBox.length === allFields.length;
    }

    async function downloadRelatorio() {
        try {
            clarity.setEvent('relatorio-demandas');
            setOpenReportModal(false);

            const fields = checkedBox.reduce((acc: any, field: string) => { acc[field] = true; return acc; }, {});

            if (Object.keys(fields).length === 0) {
                toast.error('É necessário selecionar ao menos um campo para exportar o relatório');
                return;
            }

            const filtrosMapeados = carregaFiltrosComuns();
            const filter = { ...filtrosMapeados, status: statusFiltro } as any;

            const response = await toast.promise(
                api.post('proposta-csv', { filter, fields }),
                {
                    loading: 'Gerando relatório...',
                    success: 'Relatório de Demandas gerado com sucesso!',
                    error: 'Erro ao gerar relatório de demandas. Tente novamente.'
                }
            );

            const url = window.URL.createObjectURL(new Blob([s2ab(response.data)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Relatório Demandas.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {}
    }

    const dataCheckbox = {
        identificacao: [
            { value: 'numeroProcesso', placeholder: 'Nº processo' },
            { value: 'autor', placeholder: 'Autor' },
            { value: 'codigoCliente', placeholder: 'Código do cliente' },
            { value: 'codigoCorContr', placeholder: 'Código do corresp. contratado' },
            { value: 'foroCidade', placeholder: 'Foro-cidade' },
            { value: 'reu', placeholder: 'Réu' },
            { value: 'advogadoSolici', placeholder: 'Advogado soliciante / email' },
            { value: 'idPasta', placeholder: 'Id/nº pasta' },
            { value: 'nomeCliente', placeholder: 'Nome do cliente' },
            { value: 'codigoCorresp', placeholder: 'Código do correspondente' },
        ],
        demanda: [
            { value: 'tipoDemanda', placeholder: 'Tipo de demanda' },
            { value: 'subTipo', placeholder: 'Subtipo de demanda' },
            { value: 'modalidade', placeholder: 'Modalidade' },
            { value: 'profissional', placeholder: 'Profissional necessário' },
            { value: 'status', placeholder: 'Status' },
            { value: 'operador', placeholder: 'Operador' },
            { value: 'ilha', placeholder: 'Ilha' },
            { value: 'tags', placeholder: 'Tags' },
        ],
        agendamento: [
            { value: 'dataAudiencia', placeholder: 'Data Audiência' },
            { value: 'horaAudiencia', placeholder: 'Hora Audiência' },
            { value: 'dataSolicitacao', placeholder: 'Data da solicitação' },
            { value: 'dataRealizacao', placeholder: 'Data da realização' },
            { value: 'dataModificacao', placeholder: 'Data de Modificação' },
        ],
        financeiro: [
            { value: 'valorPagoCliente', placeholder: 'Valor pago pelo cliente' },
            { value: 'valorReembolso', placeholder: 'Valor de reembolso' },
            { value: 'lucro', placeholder: 'Lucro' },
            { value: 'valorCorresp', placeholder: 'Valor correspondente' },
        ],
    }

    async function carregaGruposDeAbas() {

        const filtrosMapeados = carregaFiltrosComuns()

        setAbasCarregando(true)

        const response = await api.get('demandas/lista/abas', { params: filtrosMapeados })
        await setGruposDeAbas(response.data)
        setAbasCarregando(false)

    }

    async function listaDemandas() {

        setLoading(true)

        // Mapeamento dos filtros do frontend para o backend
        const filtrosMapeados = {
            status: statusFiltro,
            limit: 15,
            page: paginaAtual,
            ...carregaFiltrosComuns()
        }


        const response = await api.get('demandas', { params: filtrosMapeados })

        setListaDeDemandas(response.data.data)
        setPaginacao({
            pagina_atual: Number(response.data.pagination.currentPage),
            total_paginas: Number(response.data.pagination.lastPage),
            total_registros: Number(response.data.pagination.total),
            registros_por_pagina: Number(response.data.pagination.perPage)
        })
        setLoading(false)

    }

    const handleAlterarStatusFiltro = () => {
        // Se a sidebar de filtros está fechada, abre ela
        if (!isSidebarFiltrosOpen) {
            setSidebarFiltrosOpen(true);
        } else {
            // Se está aberta, fecha ela
            setSidebarFiltrosOpen(false);
        }
    };

    const handleFiltrosChange = (novosFiltros: IFiltroListaDemandas) => {
        setFiltros(novosFiltros);
    };

    const handleLimparFiltros = () => {
        resetFiltros();
    };

    const handleFecharSidebar = () => {
        setSidebarFiltrosOpen(false);
    };

    const contarFiltrosAtivos = (filtros: IFiltroListaDemandas): number => {
        let contador = 0;

        // Campos simples
        if (filtros.id) contador++;
        if (filtros.operador) contador++;
        if (filtros.solicitante) contador++;
        if (filtros.correspondente) contador++;
        if (filtros.comarca && filtros.comarca.length > 0) contador++;
        if (filtros.servico && filtros.servico.length > 0) contador++;
        if (filtros.numeroProcesso) contador++;
        if (filtros.parteEnvolvida) contador++;
        if (filtros.parteRepresentada) contador++;

        // Campos com operadores
        if (filtros.valorCliente && (filtros.valorCliente.valor !== undefined || filtros.valorCliente.valorMin !== undefined || filtros.valorCliente.valorMax !== undefined)) contador++;
        if (filtros.prazoFatal && (filtros.prazoFatal.data !== undefined || filtros.prazoFatal.dataInicio !== undefined || filtros.prazoFatal.dataFim !== undefined)) contador++;
        if (filtros.solicitadaEm && (filtros.solicitadaEm.data !== undefined || filtros.solicitadaEm.dataInicio !== undefined || filtros.solicitadaEm.dataFim !== undefined)) contador++;
        if (filtros.prazoParaAceite && (filtros.prazoParaAceite.data !== undefined || filtros.prazoParaAceite.dataInicio !== undefined || filtros.prazoParaAceite.dataFim !== undefined)) contador++;
        if (filtros.iniciadaEm && (filtros.iniciadaEm.data !== undefined || filtros.iniciadaEm.dataInicio !== undefined || filtros.iniciadaEm.dataFim !== undefined)) contador++;
        if (filtros.prazoParaConclusao && (filtros.prazoParaConclusao.data !== undefined || filtros.prazoParaConclusao.dataInicio !== undefined || filtros.prazoParaConclusao.dataFim !== undefined)) contador++;

        // Filtros específicos de audiência
        if (filtros.modalidade && filtros.modalidade.length > 0) contador++;
        if (filtros.tipoAudiencia && filtros.tipoAudiencia.length > 0) contador++;
        if (filtros.profissionalNecessario && filtros.profissionalNecessario.length > 0) contador++;

        return contador;
    };

    useEffect( () => {
        carregaGruposDeAbas()
    }, [])

    useEffect(() => {
        if (gruposDeAbas.length > 0 && abasIniciais) {
            setAbasIniciais(false)
            setStatusFiltro(gruposDeAbas[abaAtiva - 1].status)
        }
    }, [gruposDeAbas])


    useEffect(() => {
        if (statusFiltro.length === 0) return
        if(paginaAtual > 1) setPaginaAtual(1)
        else listaDemandas()
    }, [statusFiltro])

    useEffect(() => {
        if (statusFiltro.length === 0) return
        setAbasCarregando(true)
        if(paginaAtual > 1) {
            setPaginaAtual(1)
        }
        else {
            listaDemandas()
        }
        carregaGruposDeAbas()
    }, [filtros])

    useEffect(() => {
        if (statusFiltro.length === 0) return
        listaDemandas()
    }, [paginaAtual])

    const carregaPagina = (novaPagina: number) => {
        setPaginaAtual(novaPagina)
        
        setTimeout(() => {
            if (containerRef.current) {
                containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            }
        }, 100)
    }



    return (
        <Container ref={containerRef}>
            <BlocoPrincipal>    
            <CabecalhoListaDemanda
            
                emiteRelatorio={emiteRelatorio}
                alteraStatusFiltro={handleAlterarStatusFiltro}
                grupoAbas={
                <GruposDeAbasDeDemandas
                    dadosAbas={gruposDeAbas}
                    filtraPorStatus={setStatusFiltro}
                    abaAtiva={abaAtiva}
                    setAbaAtiva={setAbaAtiva}
                    loading={abasCarregando}
                />
                }
                quantidadeFiltrosAtivos={contarFiltrosAtivos(filtros)}
            />

            <ModalDefault
                id={'overlayModalRelatorio'}
                onClose={() => setOpenReportModal(false)}
                openModal={openReportModal}
                width="fit-content"
                maxWidth="1200px"
                maxHeight="auto"
            >
                <ModalTitle>
                    <div>Exportar Relatório de Demandas</div>
                    <div className="close" onClick={() => setOpenReportModal(false)}>
                        <IconClose />
                    </div>
                </ModalTitle>
                <ModalContent className="w-full max-w-6xl flex flex-col">
                    <div className="p-5 flex flex-col gap-2 overflow-y-auto max-h-[calc(100vh-300px)]">
                        <span className="title">Identificação geral</span>
                        <div className="grid grid-cols-3 gap-2">
                            {dataCheckbox.identificacao.map((item: any) => (
                                <div key={item.value} className="col-span-1 flex flex-row">
                                    <Checkbox
                                        name={item.value}
                                        value={checkedBox.includes(item.value)}
                                        onClick={handleCheckbox}
                                        placeholder={item.placeholder}
                                    />
                                </div>
                            ))}
                        </div>

                        <span className="title">Detalhes da Demanda</span>
                        <div className="grid grid-cols-3 gap-2">
                            {dataCheckbox.demanda.map((item: any) => (
                                <div key={item.value} className="col-span-1 flex flex-row">
                                    <Checkbox
                                        name={item.value}
                                        value={checkedBox.includes(item.value)}
                                        onClick={handleCheckbox}
                                        placeholder={item.placeholder}
                                    />
                                </div>
                            ))}
                        </div>

                        <span className="title">Prazos e Agendamentos</span>
                        <div className="grid grid-cols-3 gap-2">
                            {dataCheckbox.agendamento.map((item: any) => (
                                <div key={item.value} className="col-span-1 flex flex-row">
                                    <Checkbox
                                        name={item.value}
                                        value={checkedBox.includes(item.value)}
                                        onClick={handleCheckbox}
                                        placeholder={item.placeholder}
                                    />
                                </div>
                            ))}
                        </div>

                        <span className="title">Financeiro</span>
                        <div className="grid grid-cols-3 gap-2">
                            {dataCheckbox.financeiro.map((item: any) => (
                                <div key={item.value} className="col-span-1 flex flex-row">
                                    <Checkbox
                                        name={item.value}
                                        value={checkedBox.includes(item.value)}
                                        onClick={handleCheckbox}
                                        placeholder={item.placeholder}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="flex flex-row gap-3 p-5 justify-end">
                        <ButtonDefault className="cancel" onClick={handleToggleAll}>
                            {isAllSelected() ? 'Desmarcar Todos' : 'Selecionar Todos'}
                        </ButtonDefault>
                        <ButtonDefault className="continue" onClick={() => downloadRelatorio()}>
                            Exportar
                        </ButtonDefault>
                    </div>
                </ModalContent>
            </ModalDefault>

            {
                listaDeDemandas.length === 0 &&
                <ListaDemandasVazia />
            }
            {
                listaDeDemandas.length > 0 &&
                <BlocoListaDemandas
                    propostas={listaDeDemandas}
                    paginacao={paginacao}
                    loading={loading}
                    carregaPagina={carregaPagina}
                    />
            }
                </BlocoPrincipal>
            <SidebarFiltros
                isOpen={isSidebarFiltrosOpen}
                onClose={handleFecharSidebar}
                filtros={filtros}
                onFiltrosChange={handleFiltrosChange}
                onLimparFiltros={handleLimparFiltros}
                quantidadeFiltrosAtivos={contarFiltrosAtivos(filtros)}
            />
        </Container>
    )
}